import { LTLLoadItem } from './types';
// This file contains default values for LTL load items and load item breakdowns
// to be used in tests or as initial state in the store.
// It helps ensure that the application has a consistent starting point for LTL load items.
// These defaults can be overridden in specific tests or components as needed.
export const DEFAULT_LOAD_ITEM: LTLLoadItem = {
  quantity: 1,
  item: 'Pallets',
  uom: 'lbs',
  pieces: null,
  weight: null,
  class: null,
  hazmat: false,
  lengthInch: null,
  widthInch: null,
  heightInch: null,
  pcf: '',
  suggestedClass: null,
  nmfc: '',
  description: '',
  charge: null,
  loadItemHazmatDetail: null,
  volume: null,
  hazmatItems: null,
  hazmatDescription: null,
  type: '',
  quoteLoadItemBreakdown: [],
  height: null,
  length: null,
  width: null,
};

export const DEFAULT_LOAD_ITEM_BREAKDOWN: LTLLoadItem = {
  pieces: null,
  weight: null,
  class: null,
  hazmat: false,
  nmfc: '',
  description: '',
  loadItemHazmatDetail: null,
  quantity: null,
  height: null,
  length: null,
  width: null,
  uom: '',
  heightInch: null,
  lengthInch: null,
  widthInch: null,
  quoteLoadItemBreakdown: [],
};
